<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2 mt-3" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            <div class="divisor">
              {{ $t('crear_nueva_comuna') }}
            </div>
          </b-col>
        </b-row>

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="6">
              <b-form-group label-for="nombre">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="nombre" v-model="form.nombre" required
                  :placeholder="$t('nombre')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="idRegion">
                <template v-slot:label>
                  {{ $t('region') }} <span class="text-danger">*</span>
                </template>
                <b-form-select id="idRegion" v-model="form.idRegion" required>
                  <option :value="null" disabled>{{ $t('seleccione_region') }}</option>
                  <option v-for="option in opcionesRegiones" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import comunaService from '@/api/comunaService';
import Swal from 'sweetalert2';

export default {
  name: 'ComunaCrear',
  data() {
    return {
      form: {
        nombre: '',
        idRegion: null,
      },
      opcionesRegiones: [],
    };
  },
  async beforeMount() {
    const regiones = await comunaService.getRegionesOptions();
    this.opcionesRegiones = (regiones || [])
      .map(r => ({ value: r.idRegion, text: r.nombre }))
      .sort((a, b) => String(a.text || '').localeCompare(String(b.text || ''), 'es', { sensitivity: 'base' }));

    const q = this.$route.query.region;
    if (q !== undefined && q !== null && q !== '') {
      const parsed = parseInt(q, 10);
      this.form.idRegion = isNaN(parsed) ? q : parsed;
    }
  },
  methods: {
    async submitForm() {
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('revisa_datos'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Crear',
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.close();
          return;
        }

        try {
          Swal.fire({
            html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                  '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                  '<div><h3 style="color:#006393;">' + this.$t('creando') + '</h3></div>' +
                  '</div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          const response = await comunaService.create(this.form);

          if (!response || !response.data) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
            return;
          }

          Swal.fire({
            title: this.$t('creado_correctamente'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          this.$router.push({ name: 'comunas' });
        } catch (error) {
          var raw = (error && error.response) ? error.response.data : error;
          try { console.error('Create comuna error payload:', raw); } catch (e) {}

          var status = 0;
          if (error && error.response && typeof error.response.status !== 'undefined') {
            status = error.response.status;
          }

          var msg = 'Error';
          if (typeof raw === 'string') {
            msg = raw;
          } else if (raw && (raw.message || raw.Message || raw.error || raw.title || raw.detail)) {
            msg = String(raw.message || raw.Message || raw.error || raw.title || raw.detail);
          } else if (error && error.message) {
            msg = error.message;
          } else {
            try { msg = JSON.stringify(raw, null, 2); } catch (e) { msg = 'Error'; }
          }

          if (typeof msg !== 'string') {
            try { msg = JSON.stringify(msg, null, 2); } catch (e) { msg = 'Error'; }
          }

          var title = (status === 409) ? this.$t('comuna_ya_existe') :
                      (status === 400) ? this.$t('datos_invalidos') : 'Oops...';
          var icon  = (status === 409 || status === 400) ? 'warning' : 'error';

          Swal.fire({
            icon: icon,
            title: title,
            html: '<pre style="font-family: inherit;text-align:center;white-space:pre-wrap;margin:0">' + msg + '</pre>',
          });
        }
      });
    },
  },
};
</script>
